var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._g({staticClass:"btn-header-logo"},_vm.$listeners),[_c('span',{staticClass:"desktop"},[_vm._v("hussle")]),_c('span',{staticClass:"mobile"},[_vm._v("H")])])}
var staticRenderFns = []

export { render, staticRenderFns }